<template>
  <v-toolbar id="marketplace-navbar" class="px-2">
    <div style="font-size: 1.5em">
      <img :src="hawksoftLogo">
    </div>
    <v-toolbar-title>
      <router-link v-if="isConfirmed" to="/marketplace" style="text-decoration: none; color: white">Marketplace</router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-container v-if="agencyUser">
        <div class="align-right">
          Signed in as {{ agencyUser.initials }} - {{ agencyUser.name }}
          <span @click="doLogout">(<span class="" style="cursor:pointer; text-decoration: underline">Sign Out</span>)</span>
        </div>

        <div v-if="isSeatManagementEnabled && isAtMarketplacePage" class="align-right">
          <a style="color: white; text-decoration: underline" @click="navTo('/seatManagement')">Seat Management</a>
        </div>
      </v-container>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import store from '@/store';
import router from '../router.js';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Navbar',
  computed: {
    ...mapGetters(['isSeatManagementEnabled']),
    hawksoftLogo () {
      return require('../../public/assets/hawk-logo.png');
    },
    agencyUser () {
      return store.state.agencyUser;
    },
    isConfirmed () {
      return store.state.registration.status === 'EmailConfirmed';
    },
    isAtMarketplacePage () {
      return router.currentRoute.name === 'Marketplace';
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapMutations(['resetState']),
    async doLogout () {
      await this.logout();
      await this.resetState();
    },
    navTo: function (rte) {
      this.$router.push(rte);
    }
  }
};
</script>

<style scoped lang="scss">
    #marketplace-navbar {
      background-color: #145392;
      color: #FFF;
      font-weight: 700;
      font-size: .85em;
    }
    .align-right {
      text-align: right
    }
</style>
